const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)

export default [{
  path: '/booking',
  name: 'Booking',
  component: _import('booking/components/wrapper'),
  meta: {
    showInMenu: true,
    title: 'Бронирование',
    menuKey: 'booking',
    roles: ['ROLE_ADMIN', 'ROLE_WAITER']
  },
  children: [{
    path: '',
    name: 'Booking',
    component: _import('booking/components/schedule/index'),
    meta: {
      menuKey: 'booking',
      title: 'Бронирование',
      roles: ['ROLE_ADMIN', 'ROLE_WAITER']
    }
  }]
}]



// WEBPACK FOOTER //
// ./src/modules/booking/routes.js